// services/payment.js
// All payment-page network calls live here.
// NOTE: keep using our axios-based helpers (getMethod / postMethod etc.).

import { getMethod } from '../utils/api';        // <- axios instance wrapper
import { CLASSIFIED_PLANS } from '../constants/all';

// ---------- 1) Fetch primary plans ----------
export async function fetchPlans({ locationId, categoryId, isAndroid }) {
  const res = await getMethod({
    url: CLASSIFIED_PLANS,
    params: { location_id: locationId, job_category_id: categoryId },
    isAndroidWebview: isAndroid,
    // headers: { 'app-type': getAppType() },
    withStatusCode: true
  });

  // keep old shape: just return the array (component already expects it)
  return res?.data?.results || [];
}

// ---------- 2) Fetch upsell bundles ----------
export async function fetchUpsellOptions({ packageId, isAndroid }) {
  const res = await getMethod({
    url: `/advertisers/v1/package/upselling/options`,
    params: { id: packageId },
    isAndroidWebview: isAndroid,
    withStatusCode: true
  });

  // component expects { options: [...] }
  return res?.data || { options: [] };
}

// ---------- 3) Fetch order summary ----------
export async function fetchOrderSummary({
  packageId,
  upsellingId,
  isAndroid
}) {
  const res = await getMethod({
    url: `/advertisers/v1/package/order/summary/`,
    params: {
      package_id: packageId,
      ...(upsellingId ? { upselling_id: upsellingId } : {})
    },
    isAndroidWebview: isAndroid,
    withStatusCode: true
  });

  // component expects the raw summary object
  return res?.data;
}
